import {Sprite} from '@pixi/react';
import {Assets, IPointData} from 'pixi.js';
import {useMemo} from 'react';
import {AvatarInterface, AvatarOptions, lookup} from '../hooks/useCreateAvatar';

interface FullBodyAvatarProps {
    avatar: AvatarInterface,
    position: IPointData,
    scale: number,
}

export function FullBodyAvatar({avatar, position, scale}: FullBodyAvatarProps) {
    const playerOptions = useMemo(() => {
        return lookup(avatar);
    }, [avatar]);

    return <>
        {Object.keys(playerOptions).map((key) => {
            const sprite: string | undefined = playerOptions[key as AvatarOptions];
            if (!sprite) {return;}
            return <Sprite
                key={sprite}
                texture={Assets.get(sprite)}
                scale={scale * .5}
                anchor={.5}
                x={position.x}
                y={position.y}
            />;
        })}
    </>;
}
